<template>
  <!-- 组件 -->
  <div class="see_code_page" v-if="type">
    <div class="see_code_popup">
      <div class="head_info">
        <div class="head_title">查看二维码</div>
        <div class="head_close" @click="closePopup">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <div class="order_info">
        <div class="order_code_info">
          <div class="top_title">
            <div class="title_one">邀请实际承运人</div>
            <div class="title_two">扫码接单</div>
          </div>
          <div class="info_time">
            失效时间：{{ info.lastUnloadingTime || "" }}
          </div>
          <div class="code_box">
            <img class="code_img" :src="secureCodeUrl" alt="" />
          </div>

          <div class="warn">
            打开<span class="warn_company">联帮帮司机端App</span> -
            点击首页扫码接单
          </div>
          <el-button
            class="sub_but"
            :type="subType ? 'info' : 'primary'"
            :disabled="subType"
            @click="downCode()"
            >下载二维码</el-button
          >
        </div>
        <div class="order_site">
          <div class="site_box">
            <!-- 装 -->
            <div class="site_each">
              <div class="site_line"></div>
              <img
                class="site_icon"
                src="@/assets/place-order/transport-start.png"
                alt=""
              />
              <div class="site_info">
                <div class="district">{{ info.shipperAddress || "" }}</div>
                <div class="position">
                  {{ info.shipperDetailAddress || "" }}
                </div>
              </div>
            </div>
            <!-- 卸 -->
            <div class="site_each">
              <img
                class="site_icon"
                src="@/assets/place-order/transport-end.png"
                alt=""
              />
              <div class="site_info">
                <div class="district">{{ info.consigneeAddress || "" }}</div>
                <div class="position">
                  {{ info.consigneeDetailAddress || "" }}
                </div>
              </div>
            </div>
          </div>
          <div class="user_info">
            <div class="company">合作公司：{{ branchName }}</div>
            <div class="order_code">
              货源单号：{{ info.mainOrderNumber || "" }}
            </div>
            <div class="company_type">{{ info.coalBigTypeName || "" }}</div>
            <div class="company_user">
              <img
                class="user_icon"
                src="@/assets/place-order/user-img.png"
                alt=""
              />
              <div class="company_name">{{ info.createdByName || "" }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup-code
      ref="popupCode"
      @closeCode="closeCode"
      :info="info"
      :codeUrl="codeUrl"
    ></popup-code>
    <!-- <div class="" v-if=""></div> -->
  </div>
</template>

<script>
import { Loading } from "element-ui";
import popupCode from "@/components/popupCode/index";
export default {
  components: {
    popupCode
  },
  props: {
    branchName: {
      type: String,
      default: ""
    },
    codeUrl: {
      type: String,
      default: ""
    },
    type: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      subType: false,
      loadingInstance: ""
    };
  },

  //过滤器
  filters: {},
  // 计算属性
  computed: {
    secureCodeUrl() {
      let code = this.codeUrl;
      // if (this.codeUrl && this.codeUrl.startsWith("http://")) {
      //   code = this.codeUrl.replace("http://", "https://");
      // }
      // console.log("?????", code);
      return code;
    }
  },
  // 监听器
  watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    downCode() {
      this.gain(() => {
        this.$refs.popupCode.down();
      });
    },
    gain(callback) {
      this.subType = true;
      this.loadingInstance = Loading.service({
        lock: true,
        text: "下载中",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$forceUpdate();
      setTimeout(() => {
        if (callback) {
          callback();
        }
      }, 500);
    },
    closeCode() {
      this.loadingInstance.close();
      this.$message({
        showClose: true,
        message: "下载成功",
        type: "success"
      });
      this.subType = false;
    }
  }
};
</script>

<style scoped lang="scss">
.see_code_page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #00000030;
  border-radius: 0px 0px 0px 0px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  .see_code_popup {
    width: 836px;
    height: 476px;
    background: #ffffff;
    border-radius: 14px 14px 14px 14px;
    .head_info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 14px 14px 18px;
      box-sizing: border-box;
      .head_title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
      }
      .head_close {
        font-size: 22px;
        color: #000000;
        cursor: pointer;
      }
    }
    .order_info {
      display: flex;
      .order_code_info {
        width: 430px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top_title {
          padding-top: 25px;
          box-sizing: border-box;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 800;
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          .title_one {
            color: #333333;
            margin-right: 8px;
          }
          .title_two {
            color: #4186ef;
          }
        }
        .info_time {
          margin-top: 10px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 14px;
          color: #777777;
        }
        .code_box {
          margin-top: 20px;
          width: 183px;
          height: 183px;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #d9d9d9;
          display: flex;
          align-items: center;
          justify-content: center;
          .code_img {
            width: 180px;
            height: 180px;
          }
        }
        .warn {
          margin-top: 15px;
          text-align: center;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 14px;
          color: #aaaaaa;
          .warn_company {
            color: #333;
          }
        }
        .sub_but {
          margin-top: 14px;
          width: 145px;
          height: 38px;
        }
      }
      .order_site {
        width: 360px;
        height: 396px;
        background-image: url("~@/assets/place-order/code-back.png");
        background-size: 100% 100%;
        .site_box {
          margin-top: 40px;
          padding-left: 30px;
          box-sizing: border-box;
          .site_each {
            display: flex;
            position: relative;
            .site_line {
              position: absolute;
              top: 20px;
              left: 9px;
              bottom: 0px;
              border: 1px solid #aaaaaa;
            }
            .site_icon {
              width: 20px;
              height: 20px;
              margin-right: 15px;
            }
            .site_info {
              .district {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #000000;
              }
              .position {
                width: 260px;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #777777;
                margin-top: 10px;
                height: 44px;
                box-sizing: border-box;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
        .user_info {
          padding: 20px 30px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .company {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #777777;
          }
          .order_code {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #777777;
            margin-top: 10px;
          }
          .company_type {
            margin-top: 10px;
            max-width: 300px;

            border-radius: 57px 57px 57px 57px;
            border: 1px solid #4186ef;
            padding: 0 12px;
            display: flex;
            align-items: center;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #4186ef;
          }
          .company_user {
            margin-top: 30px;
            display: flex;
            align-items: center;
            .user_icon {
              width: 40px;
              height: 40px;
              margin-right: 10px;
              border-radius: 40px;
            }
            .company_name {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              width: 240px;
            }
          }
        }
      }
    }
  }
}
</style>
